export interface PostSearchSchema {
  search?: string,
  dateRange?: DateOption,
  schools?: number[],
  districts?: number[],
}

export enum DateOption {
  Last3Months = 'Last 3 Months',
  Last6Months = 'Last 6 Months',
  LastYear = 'Last Year',
  Last2Years = 'Last 2 Years',
}

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace DateOption {
  export function Values() {
    return [
      DateOption.Last3Months,
      DateOption.Last6Months,
      DateOption.LastYear,
      DateOption.Last2Years,
    ]
  }

  export function Parse(value?: DateOption) {
    return DateOption.Values().find(v => v === value)
  }

  export function TimeRange(value?: DateOption): { begin?: Date, end?: Date } {
    if (!value)
      return {}

    const now = new Date()
    now.setSeconds(0)
    now.setMinutes(0)

    const then = new Date(now)

    switch (value) {
      case DateOption.Last3Months:
        then.setDate(now.getDate() - (31 * 3))
        return { end: then }
      case DateOption.Last6Months:
        then.setDate(now.getDate() - (31 * 6))
        return { end: then }
      case DateOption.LastYear:
        then.setDate(now.getDate() - 365)
        return { end: then }
      case DateOption.Last2Years:
        then.setDate(now.getDate() - (365 * 2))
        return { end: then }
      default:
        return {};
    }
  }
}
